function numberFormat(number, currency = 'EUR', digits=2, is_round = false) {
  const lang_by_currency = {
    COP: 'es-CO',
    EUR: 'es-CO',
    USD: 'en-US',
    BRL: 'es-CO'
  }
  currency = currency.toUpperCase()
  if (!lang_by_currency[currency]) return number

  const lang_code = lang_by_currency[currency]

  number = typeof number === 'string' ? +number : number

  if(is_round)
  number = Math.ceil(number);

  const price = new Intl.NumberFormat(lang_code, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,

  }).format(number)

  if (currency !== 'USD') {return price }
  else if (currency === 'USD') {return `${price.replace('.', '-').replace(/,/g, '.').replace('-', ',')} ${currency}`}
}
export default numberFormat
